export interface VerifyPhoneNumberViaEmailModel{
    email: string,
    code:string
}